module.exports = __webpack_public_path__ + "static/media/search.6cfe3f6a.svg";